import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, IconButton } from "@mui/material";
import { SearchAndFilterDialog } from "../../../popups/SearchAndFilter";
import SearchIcon from "@mui/icons-material/Search";
import { textColor } from "../../../../assets/styles/colors";
import { searchAndFilterDialogStore } from "../../../../stores/searchAndFilterDialogStore";
export const SearchButton = () => {
    return (_jsxs(Grid, { item: true, children: [_jsx(IconButton, { onClick: searchAndFilterDialogStore.open, sx: { color: textColor, marginTop: '4px' }, children: _jsx(SearchIcon, {}, void 0) }, void 0), _jsx(SearchAndFilterDialog, {}, void 0)] }, void 0));
};
//# sourceMappingURL=SearchButton.js.map